import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export function AdminWaitlist() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/waitlist").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const notify = async (id) => {
    try {
      const r = await api.post(`/admin/waitlist/${id}/notify`);
      toast.info(r.data.status === "sent" ? "Notified" : `Email ${r.data.status}`);
      load();
    } catch (e) { toast.error("Failed"); }
  };
  return (
    <div>
      <h1 className="font-display text-3xl font-bold">Waitlist</h1>
      <p className="text-sm text-stone-500 mt-1">Attendees waiting for a seat to open up.</p>
      <div className="mt-6 cgc-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60">
            <tr>{["Name","Email","Phone","Joined","Notified",""].map(h => <th key={h} className="text-left p-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {items.map((w) => (
              <tr key={w.id} className="border-t border-border">
                <td className="p-3">{w.name}</td>
                <td className="p-3">{w.email}</td>
                <td className="p-3">{w.phone || "—"}</td>
                <td className="p-3 text-xs">{fmtDate(w.created_at)}</td>
                <td className="p-3">{w.notified ? <span className="text-xs px-2 py-0.5 bg-green-100 text-green-900 rounded">Notified</span> : <span className="text-xs text-stone-500">—</span>}</td>
                <td className="p-3"><Button size="sm" variant="outline" onClick={() => notify(w.id)} data-testid={`notify-${w.id}`}>Notify</Button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="text-center p-10 text-stone-500">No waitlist entries</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
